import { Flex } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { withNotAuth } from 'hocs/withNotAuth';

import s from './CenterFormLayout.module.scss';

const CenterFormLayout: React.FC = () => {
  return (
    <>
      <Notifications position="top-center" limit={3} />
      <Flex justify="center" className={s.root}>
        <div className={s.root__container}>
          <Outlet />
        </div>
      </Flex>
    </>
  );
};

export default withNotAuth(CenterFormLayout);
